export enum FileTypeEnum {
    video = 35,
    image = 36,
    pdf = 37,
    indexed = 45
}